// extracted by mini-css-extract-plugin
export default {"topBox":"styles_topBox__Akv3b","title":"styles_title__LSFyc","button":"styles_button__6OzU7"};